const Zone = {

    // FIELDS
    "premise": "Premise",
    "name": "Name",
    "search": "Search",

    // PAGE HEADER
    "zone": "Zone",

    // ERROR
    "error_premise": "Select Premise",
    "error_name": "Enter Name",

    // BUTTON
    "add_zone": "Add Zone",
    "edit_zone": "Edit Zone",
    "delete_zone": "Delete Zone",

    // TAGLINE
    "zone_tagline": 'Add New Building Zone',
    "zone_sub_tagline": 'Manage your zones, levels, and units efficiently',

}

export default Zone;